import { render, staticRenderFns } from "./AntecedenteDetalleModal.vue?vue&type=template&id=6e641fe2"
import script from "./AntecedenteDetalleModal.vue?vue&type=script&lang=js"
export * from "./AntecedenteDetalleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports